__turbopack_context__.v({
  "container": "VisaRenewal-module__6iOFFG__container",
  "docsItem": "VisaRenewal-module__6iOFFG__docsItem",
  "docsLabel": "VisaRenewal-module__6iOFFG__docsLabel",
  "docsList": "VisaRenewal-module__6iOFFG__docsList",
  "docsNumber": "VisaRenewal-module__6iOFFG__docsNumber",
  "docsSection": "VisaRenewal-module__6iOFFG__docsSection",
  "emphasis": "VisaRenewal-module__6iOFFG__emphasis",
  "feesIntro": "VisaRenewal-module__6iOFFG__feesIntro",
  "feesSection": "VisaRenewal-module__6iOFFG__feesSection",
  "feesTable": "VisaRenewal-module__6iOFFG__feesTable",
  "orLabel": "VisaRenewal-module__6iOFFG__orLabel",
  "reminderDot": "VisaRenewal-module__6iOFFG__reminderDot",
  "reminderItem": "VisaRenewal-module__6iOFFG__reminderItem",
  "remindersList": "VisaRenewal-module__6iOFFG__remindersList",
  "remindersSection": "VisaRenewal-module__6iOFFG__remindersSection",
  "section": "VisaRenewal-module__6iOFFG__section",
  "sectionSubtitle": "VisaRenewal-module__6iOFFG__sectionSubtitle",
  "solutionLabel": "VisaRenewal-module__6iOFFG__solutionLabel",
  "stepLink": "VisaRenewal-module__6iOFFG__stepLink",
  "tableNote": "VisaRenewal-module__6iOFFG__tableNote",
  "tableWrapper": "VisaRenewal-module__6iOFFG__tableWrapper",
  "title": "VisaRenewal-module__6iOFFG__title",
  "videoIframe": "VisaRenewal-module__6iOFFG__videoIframe",
  "videoLabel": "VisaRenewal-module__6iOFFG__videoLabel",
  "videoPlaceholder": "VisaRenewal-module__6iOFFG__videoPlaceholder",
  "videoWrapper": "VisaRenewal-module__6iOFFG__videoWrapper",
  "warningCard": "VisaRenewal-module__6iOFFG__warningCard",
  "warningError": "VisaRenewal-module__6iOFFG__warningError",
  "warningIcon": "VisaRenewal-module__6iOFFG__warningIcon",
  "warningSolution": "VisaRenewal-module__6iOFFG__warningSolution",
  "warningsContact": "VisaRenewal-module__6iOFFG__warningsContact",
  "warningsEmail": "VisaRenewal-module__6iOFFG__warningsEmail",
  "warningsList": "VisaRenewal-module__6iOFFG__warningsList",
  "warningsSection": "VisaRenewal-module__6iOFFG__warningsSection",
});
